import { t } from 'i18next';
import { Svgs } from '../../../../../../assets/svg';
import { Button } from '../../../../../../components/buttons/Button';
import { Trans } from 'react-i18next';
import { Grid, Link, Typography } from '@mui/material';
import { Colors, Spacing } from '../../../../../../themes';
import { Ref } from 'react';

interface MobileUpsellFooterProps {
  advicePrice: string;
  openDoc: (description: 'Terms of Service' | 'Privacy Policy') => Promise<void>;
  onUpgradeToPremium: () => Promise<void>;
  footerRef?: Ref<HTMLDivElement>;
}

const MobileUpsellFooter: React.FC<MobileUpsellFooterProps> = ({
  advicePrice,
  openDoc,
  onUpgradeToPremium,
  footerRef,
}) => {
  return (
    <Grid
      ref={footerRef}
      sx={{
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: Colors.tertiaryBase,
        boxShadow: '0 4px 7px 1px rgba(30, 41, 105, 0.2), 0 -4px 7px 1px rgba(30, 41, 105, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        zIndex: 5,
      }}>
      <Typography
        mt={'20px'}
        sx={{ alignItems: 'baseline' }}
        variant='p26BoldMontserrat'
        color='secondary'>
        {advicePrice}
        <Typography variant='p16Montserrat' color='secondary'>
          {t('perMonth')}
        </Typography>
      </Typography>
      <Typography
        sx={{ textAlign: 'center', display: 'inline' }}
        mb={'10px'}
        mx={Spacing.xxs}
        variant='p12'
        color='secondary'>
        {t('ThisSubscriptionRenewsAutomatically', {
          interval: t('month'),
        })}{' '}
        <Typography className='link-wrapper' variant='p12' color='secondary'>
          <Trans
            i18nKey='PleaseSeeTOSAndPrivacyPolicy'
            components={{
              TermsOfService: <Link onClick={() => openDoc('Terms of Service')} />,
              PrivacyPolicy: <Link onClick={() => openDoc('Privacy Policy')} />,
            }}
          />
        </Typography>
      </Typography>
      <Button
        onClick={onUpgradeToPremium}
        color='primary'
        style={{ width: '90%', minWidth: '200px', marginBottom: '20px', padding: '10px' }}>
        <Svgs.DisplaySmallPrimaryLightLock style={{ marginRight: '10px' }} />
        {t('UpgradeToPremium')}
      </Button>
    </Grid>
  );
};

export default MobileUpsellFooter;
